<template>
    <nav id="globalNav" class="onlyLogo">
        <div class="wrapper">
            <div class="row">
                <div class="logo">
                    <a href="/"><img src="/assets/img/common/logo.svg" alt="ALOCO"></a>
                </div>
            </div>
        </div>
        <div class="spActions wrapper">
<!--            <div class="back">-->
<!--                <div class="arrowButton"></div>-->
<!--            </div>-->
            <div class="title">
                <div id="navTitle">{{ title }}</div>
            </div>
        </div>
    </nav>
</template>

<script>
export default {
    data() {
        return {
            title: null
        }
    },
    mounted() {
        const pathname = window.location.pathname
        if (pathname.includes('faq')) {
            this.title = 'よくあるご質問'
        }
        if (pathname.includes('tos')) {
            this.title = '利用規約'
        }
        if (pathname.includes('privacy_policy')) {
            this.title = 'プライバシーポリシー'
        }
        if (pathname.includes('company')) {
            this.title = '運営会社'
        }
        if (pathname.includes('login')) {
            this.title = 'ログイン・会員登録'
        }
        if (pathname.includes('signup/step_1')) {
            this.title = '会員登録'
        }
        if (pathname.includes('signup/step_2')) {
            this.title = '会員登録'
        }
        if (pathname.includes('signup/step_3')) {
            this.title = '会員登録'
        }
    }
}
</script>
